export const discoveryUrl = 'https://broadcast-services.preproduction-api.immediate.co.uk/docs/v1/swagger.json,';
export const environments = {
  staging: 'https://broadcast-services.staging-api.immediate.co.uk',
  preproduction: 'https://broadcast-services.preproduction-api.immediate.co.uk',
  production: 'https://broadcast-services.api.immediate.co.uk'
};
export const defaultHeaders = {
  'Content-Type': 'application/json',
  accept: 'application/json'
};
export const qsOptions = {
  arrayFormat: 'comma'
};
export default {
  discoveryUrl,
  environments,
  defaultHeaders,
  qsOptions
};